import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { LocalizacionService } from '../../../services/localizacion/localizacion.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ConfigService } from '../../../services/config/config.service'
import { FleteService } from '../../..//services/flete/flete.service';

@Component({
  selector: 'app-flete-ciudad',
  templateUrl: './flete-ciudad.component.html',
  styleUrl: './flete-ciudad.component.scss',
  standalone: false,
  providers: [MessageService]
})
export class FleteCiudadComponent implements OnInit {
  loadMenu: boolean = true;
  load: boolean = false;
  token: any = {};
  infoEmpresa: any = {};
  infoParametrizacion: any = {};
  lsRangos: Array<any> = [];
  listDptos: Array<any> | undefined;
  lsCities: Array<any> | undefined;
  lsFleteCiudad: Array<any> = [];
  selectedDpto: any = {};
  selectedCity: any = {};

  constructor(private message: MessageService,
    private localizacion: LocalizacionService,
    private config: ConfigService,
    private flete: FleteService) { }

  ngOnInit(): void {
    this.token = JSON.parse(localStorage.getItem('token') ?? "".toString());
    this.infoEmpresa = JSON.parse(localStorage.getItem('empresa') ?? "[]");
    this.listDptos = JSON.parse(localStorage.getItem('listDptos') ?? "[]");
    this.infoParametrizacion = JSON.parse(localStorage.getItem('parametros') ?? "");
  }

  getCities = () => {
    this.localizacion.getCities(this.token.token, this.selectedDpto.idDepartamento).subscribe({
      next: (response) => {
        this.lsCities = response as Array<any>;
      },
      error: (error: HttpErrorResponse) => { this.config.handleError(error); }
    })
  }
  /**
   * Generar los rangos de las variables para luego asignaarlas si ya estan incluidas
   *
   * @returns {*}
   */
  getRangos = () => {
    this.flete.getRangoProveedor(this.token.token).subscribe({
      next: (response) => {
        this.lsRangos = response as Array<any>;
        if (this.lsRangos.length == 0) this.message.add({ severity: 'success', detail: 'No hay rangos creados' })
        else {
          // revsiar si hay datos en la ciudad
          this.flete.getFleteCiudad(this.token.token, this.selectedCity.idCiudad).subscribe({
            next: (response) => {
              let array: Array<any> = response as Array<any>;
              for (const item of array) {
                console.log(item);
                const position: number = this.lsRangos?.findIndex((row: any) => {
                  return row.idRangoPesoProveedor == item.idRangoProveedor
                });
                if (position > -1) {
                  this.lsRangos[position].idFleteCiudad = item.idFleteCiudad;
                  this.lsRangos[position].costo = item.costo;
                  this.lsRangos[position].valor = item.valor;
                  this.lsRangos[position].pedidoMinimo = item.pedidoMinimo;
                }
              }
            },
            error: (error: HttpErrorResponse) => { this.config.handleError(error); }
          })
        }
        this.load = false;


      },
      error: (error: HttpErrorResponse) => {
        this.load = false;
        this.message.add({ severity: 'success', detail: 'Se ha presentado un error, favor intente nuevamente' })
        this.config.handleError(error)
      }
    })



  };

  setFlete = (row: any) => {
    if ((row.valor > 0) && (row.pedidoMinimo > 0)) {
      const data = {
        "idFleteCiudad": row.idFleteCiudad ?? 0,
        "idCiudad": this.selectedCity.idCiudad,
        "idRangoProveedor": row.idRangoPesoProveedor,
        "idProducto": this.infoParametrizacion.idProductoFlete ?? 0,
        "costo": row.costo ?? 0,
        "valor": row.valor,
        "pedidoMinimo": row.pedidoMinimo ?? 0
      }

      this.flete.setFleteCiudad(this.token.token, data).subscribe({
        next: (response) => {
          let info: any = response as any;
          row.idFleteCiudad = info.idFleteCiudad;
          row.message = "<div class='p-message p-message-success p-3'>Procesamiento exítoso</div>"
        },
        error: (error: HttpErrorResponse) => { this.config.handleError(error) }
      });
    }
    else
      row.message = "<div class='p-message p-message-warn p-3'>Favor relacione la información resaltada con *</div>"
  }

}
